export default {"src":"/_next/static/media/cx4stars.47dd9b21.svg","height":44,"width":250,"blurWidth":0,"blurHeight":0};